import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MapPin, Phone, Mail, MessageCircle, Linkedin, Instagram, Facebook, ShieldCheck } from "lucide-react";
export default function InformativeFooter() {
  const quickLinks = [{
    label: "Soluções",
    to: "/SolutionsPage"
  }, {
    label: "Equipamentos",
    to: "/EquipmentPage"
  }, {
    label: "Conteúdo Técnico",
    to: "/#conteudo-tecnico"
  }, {
    label: "Empresa",
    to: "/CompanyPage"
  }, {
    label: "Contato",
    to: "/ContactPage"
  }];
  const contactInfo = [{
    icon: MapPin,
    text: "Brasil",
    href: null
  }, {
    icon: Phone,
    text: "+55 (14) 3324 5757",
    href: "tel:+551433245757"
  }, {
    icon: Mail,
    text: "contato@doctorice.com.br",
    href: "mailto:contato@doctorice.com.br"
  }, {
    icon: MessageCircle,
    text: "WhatsApp Suporte",
    href: "https://wa.me/551433245757"
  }];
  return <footer id="rodapé-informativo" className="bg-primary text-primary-foreground relative overflow-hidden border-t border-white/10">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/technical_grid_pattern.png)] bg-repeat bg-[length:50px_50px]" />
      
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl bg-[radial-gradient(circle_at_center,rgba(199,235,255,0.05)_0%,transparent_50%)] pointer-events-none" />

      <div className="container mx-auto px-6 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://doctorice.10web.cloud/wp-content/uploads/2026/02/doctorice_footer_logo.png" alt="Doctorice Logo" className="h-7 object-contain" />
            </Link>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/doctorice_footer_brand_logo.png" alt="Doctorice Logo" className="h-7 object-contain" />
            <p className="text-primary-foreground/70 text-sm leading-relaxed max-w-xs">
              Engenharia térmica e controle de temperatura e umidade para aplicações críticas. 
              Confiabilidade operacional para ambientes médico-hospitalares e industriais.
            </p>
            <div className="flex items-center gap-4 pt-2">
              <Link to="#" aria-label="LinkedIn" className="text-primary-foreground/60 hover:text-ring transition-colors duration-300">
                <Linkedin className="h-5 w-5" />
              </Link>
              <Link to="#" aria-label="Instagram" className="text-primary-foreground/60 hover:text-ring transition-colors duration-300">
                <Instagram className="h-5 w-5" />
              </Link>
              <Link to="#" aria-label="Facebook" className="text-primary-foreground/60 hover:text-ring transition-colors duration-300">
                <Facebook className="h-5 w-5" />
              </Link>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-base font-bold uppercase tracking-wider text-white">Links Rápidos</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.to} className="text-sm text-primary-foreground/70 hover:text-ring transition-colors duration-200 flex items-center gap-2 group">
                    <span className="h-px w-0 bg-ring transition-all duration-300 group-hover:w-3" />
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-base font-bold uppercase tracking-wider text-white">Contato</h3>
            <ul className="space-y-4">
              {contactInfo.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-sm text-primary-foreground/70">
                  <item.icon className="h-5 w-5 text-ring shrink-0 mt-0.5" />
                  {item.href ? <Link to={item.href} className="transition-colors !text-base hover:text-white">
                      {item.text}
                    </Link> : <span>{item.text}</span>}
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="text-base font-bold uppercase tracking-wider text-white">Certificações</h3>
            <p className="text-sm text-primary-foreground/70">
              Compromisso com normas técnicas e qualidade assegurada.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="bg-white/5 border border-white/10 p-3 rounded-lg backdrop-blur-sm hover:bg-white/10 transition-colors duration-300 flex items-center justify-center h-16 w-16">
                 <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/iso_9001_badge.png" alt="ISO 9001" className="h-full w-auto object-contain opacity-90" />
              </div>
              <div className="bg-white/5 border border-white/10 p-3 rounded-lg backdrop-blur-sm hover:bg-white/10 transition-colors duration-300 flex items-center justify-center h-16 w-16">
                 <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1553755/img/iso_14001_badge.png" alt="ISO 14001" className="h-full w-auto object-contain opacity-90" />
              </div>
              <div className="bg-white/5 border border-white/10 p-3 rounded-lg backdrop-blur-sm hover:bg-white/10 transition-colors duration-300 flex items-center justify-center h-16 w-16">
                 <ShieldCheck className="h-8 w-8 text-ring/80" />
              </div>
            </div>
          </div>

        </div>

        <Separator className="my-10 bg-white/10" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-primary-foreground/40">
          <div className="text-center md:text-left">
            <p className="!text-[hsl(0,0%,0%)] !font-bold">© 2026 DOCTORICE. Todos os direitos reservados.</p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-6">
            <Link to="#" className="transition-colors !font-bold !text-[hsl(0,0%,0%)] hover:text-ring">Política de Privacidade</Link>
            <Link to="#" className="transition-colors !font-bold !text-[hsl(0,0%,0%)] hover:text-ring">Termos de Uso</Link>
          </div>

          <div className="text-center md:text-right">
            <p className="!font-bold !text-[hsl(0,0%,0%)]">Desenvolvido por DOCTORICE Engenharia</p>
          </div>
        </div>
      </div>
    </footer>;
}